//REACT
import React from "react";

import { makeStyles } from "@material-ui/core/styles";

//Componentes
import GridContainer from "components/Grid/GridContainer.js";

import Plan01 from "assets/img/sii-logo.png";
import Plan04 from "assets/img/f04.png";

import ItemPlanes from "./ItemPlanes";

import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
const useStyles = makeStyles(headersStyle);

export default function Planes() {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.container}>
        <GridContainer justify="center">
          <ItemPlanes
            imagen={Plan01}
            titulo="Certificado Digital SII."
            precio={[<strong>{window.desdeFES}</strong>]} //"This is ", <strong>not</strong>,  "working.
            descripcion="I.V.A incluido. Acreditado por el Servicio de Impuestos Internos"
            link01="/compra/firma-simple"
            txtBoton01="⠀COMPRAR⠀"
            link02="/descargar-simple"
            txtBoton02="DESCARGAR"
          />
          {/*<ItemPlanes
              imagen={Plan02}
              titulo="Firma On-Line de documentos"
              precio={[<strong>Desde $2.500</strong>]} //"This is ", <strong>not</strong>,  "working.
              descripcion="Firma tus documentos de manera más simple y rápida"
              link01="/compra/firma-online"
              txtBoton01="COMPRAR"
              link02="/firmar"
              txtBoton02={[<span>&nbsp;&nbsp;</span>,"FIRMAR",<span>&nbsp;&nbsp;</span>]}
            />
            <ItemPlanes
              imagen={Plan03}
              titulo="Integración de firmas"
              precio={[<strong>Desde 10U.F.</strong>]} //"This is ", <strong>not</strong>,  "working.
              descripcion="Fácil de integrar y sin costos de setup"
              link01="/compra/firma-avanzada"
              txtBoton01="VER MAS"
              link02=""
              txtBoton02={null}
            />*/}
          <ItemPlanes
            imagen={Plan04}
            titulo="Firma avanzada con Token"
            precio={[<strong>{window.desdeFEA}</strong>]} //"This is ", <strong>not</strong>,  "working.
            descripcion="I.V.A. Incluído. Firma avanzada acreditada por el Ministerio de Economía"
            link03="/compra/firma-token"
            txtBoton03="COMPRAR"
            // link02=""
            //txtBoton02={null}
            //link01= ""
          />
        </GridContainer>
      </div>
    </div>
  );
}
